import React from "react";
import ReactDOM from "react-dom/client";
/////////////table css///////
import "mdbreact/dist/css/mdb.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
////////////////////////////
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-notifications-component/dist/theme.css";

import { BrowserRouter as Router } from "react-router-dom";
import env from "react-dotenv";
if (process.env.REACT_APP_PRODUCTION === "PRODUCTION") {
  console.log = () => {};
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <App />
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
